import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";
import { hideLoader, showLoader } from "./loaderSlice";
import { uploadFile } from "../../utils/uploadFiles";

export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async ({ status, filterData }) => {
    try {
      const queryParams = new URLSearchParams();
      const combinedFilter = { ...(filterData || {}) };

      if (status) {
        combinedFilter.status = status;

        // Optional special case for UNPAID
        if (status === "UNPAID") {
          combinedFilter.paymentStatus = status;
          combinedFilter.status = "PENDING";
        }
      }

      if (Object.keys(combinedFilter).length > 0) {
        queryParams.append("filterData", JSON.stringify(combinedFilter));
      }

      // if (filterData) {
      //   queryParams.append("filterData", JSON.stringify({ ...filterData }));
      // }

      const response = await api("get", endPoints.ORDERS + "?" + queryParams);
      return response.data;
    } catch (error) {
    }
  }
);

export const fetchOrderById = createAsyncThunk(
  "order/fetchOrderById",
  async (id) => {
    const response = await api("get", endPoints.ORDER_DETAILS + id);
    return response.data;
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const response = await api("put", endPoints.ORDER_STATUS + id, {
        status,
      });

      if (response.success) {
        thunkAPI.dispatch(fetchOrderById(response.data._id));
      }
      thunkAPI.dispatch(hideLoader());
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const orderRework = createAsyncThunk(
  "order/orderRework",
  async ({ id, newRework, oldReworks, setVisible }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const image = await uploadFile(newRework.beforeImage);
      newRework.beforeImage = image.path;

      const payload = {
        ...oldReworks,
        reWorks: [...(oldReworks?.reWorks || []), { ...newRework }],
      };

      const response = await api("post", endPoints.ORDER_REWORK + id, {
        ...payload,
      });

      if (response.success) {
        thunkAPI.dispatch(fetchOrderById(response.data._id));
      }
      setVisible(false);
      thunkAPI.dispatch(hideLoader());
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    orderDetails: {},
    orders: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearOrders: (state) => {
      state.orders = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })
      .addCase(fetchOrderById.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.orderDetails = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      });
  },
});
export const { clearOrders } = ordersSlice.actions;

export default ordersSlice.reducer;
